import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import Container from '@mui/material/Container';
import { Snackbar } from '@packages/shared';
import { useCookies } from '@packages/utilities';
import { useRouter } from 'next/router';
import { Header } from '../Header';
import { Footer } from '../Footer';

const DynamicTestPanel = dynamic(
  () => import('@packages/shared/src/components/TestPanel/TestPanel'),
  {
    ssr: false,
  },
);

export interface PageLayoutOrderProps {
  /** React children nodes */
  children?: ReactNode;
}
const TestPanelWrapper: React.FC = () => {
  const router = useRouter();
  const { query } = router;

  return (
    typeof window !== 'undefined' &&
    window.location.href.indexOf('empirie.dev') > 0 &&
    !query.skipTP && <DynamicTestPanel />
  );
};
/**
 * Global PageLayout component which includes Header, PromotionBanner, and Footer
 * */
export const PageLayoutOrder = ({ children }: PageLayoutOrderProps) => {
  const { getCookies } = useCookies();
  const cookies = getCookies();
  const isNativeApp = cookies.appView === 'true';

  return (
    <>
      <TestPanelWrapper />
      {!isNativeApp && <Header />}
      <Container component="main" sx={{ py: 3 }}>
        <Snackbar />
        {children}
      </Container>
      {!isNativeApp && <Footer type="socket" />}
    </>
  );
};
